import { render, staticRenderFns } from "./BufferSetup.vue?vue&type=template&id=32907517&"
import script from "./BufferSetup.vue?vue&type=script&lang=js&"
export * from "./BufferSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports